import { ITradeComment } from '@shared/models';
import { createFeatureSelector, createSelector } from '@ngrx/store';
import { State } from './state';

export const getState = createFeatureSelector<State>('trade');

export const getLoading = createSelector(
  getState,
  (state: State) => state.loading
);

export const getTrade = createSelector(
  getState,
  (state: State) => state.data
);
